import * as React from "react";
import clsx from "clsx";
const GridContext = React.createContext({
  element: "div"
});
const Grid = (props) => {
  const {
    align,
    borderColor,
    borderWeight,
    children,
    className,
    equalHeight,
    element: Element = "div",
    gridRef,
    gutter = "default",
    horizontalGutter,
    id,
    noWrap,
    onTransitionEnd,
    reverse,
    style,
    verticalGutter,
    wrap,
    theme
  } = props;
  const classNames = clsx(
    "grid",
    "grid--gutter-".concat(gutter),
    {
      "grid--equalheight": equalHeight,
      ["grid--horizontal-gutter-".concat(horizontalGutter)]: !!horizontalGutter,
      ["grid--vertical-gutter-".concat(verticalGutter)]: !!verticalGutter,
      ["grid--border-".concat(borderWeight)]: !!borderWeight,
      ["grid--border-".concat(borderColor)]: !!borderColor
    },
    reverse == null ? void 0 : reverse.map((i) => "grid--reverse-".concat(i)),
    align == null ? void 0 : align.map((i) => "grid--".concat(i)),
    noWrap && (Array.isArray(noWrap) ? noWrap.map((item) => "grid--no-wrap-".concat(item)) : "grid--no-wrap-xs"),
    wrap == null ? void 0 : wrap.map((i) => "grid--wrap-".concat(i)),
    className
  );
  const contextValue = React.useMemo(() => ({ element: Element }), [Element]);
  const content = /* @__PURE__ */ React.createElement(GridContext.Provider, { value: contextValue }, children);
  if (Element === "ul") {
    return /* @__PURE__ */ React.createElement(
      Element,
      {
        role: "list",
        id,
        className: classNames,
        style,
        onTransitionEnd,
        ref: gridRef,
        "data-theme": theme
      },
      content
    );
  }
  if (Element === "ol") {
    return /* @__PURE__ */ React.createElement(
      Element,
      {
        role: "list",
        id,
        className: classNames,
        style,
        onTransitionEnd,
        ref: gridRef,
        "data-theme": theme
      },
      content
    );
  }
  return /* @__PURE__ */ React.createElement(Element, { id, className: classNames, style, onTransitionEnd, ref: gridRef, "data-theme": theme }, content);
};
export {
  Grid,
  GridContext
};
